export default __webpack_public_path__ + "static/media/img_step_situation04.ffcecc5f.jpg";